import { initializeStorageService } from './storage-service';

export const useInitializeStorage = (type?: 'wxt', storage?: unknown) => {
  initializeStorageService(type, storage);
};
